const en = {
    common: {
        save: 'Save',
        cancel: 'Cancel',
        cancelUpper: 'CANCEL',
        delete: 'Delete',
        deleteUpper: 'DELETE',
        edit: 'Edit',
        confirm: 'Confirm',
        close: 'Close',
        loading: 'Loading...',
        error: 'Something went wrong',
        requestFailed: 'Something went wrong, please try again later.',
        success: 'Done',
        okay: 'Okay',
        submit: 'Submit',
        notAvailable: 'N/A',
        emptySection: 'Nothing to show, Empty Section',
    },
    cart: {
        subtotal: 'Subtotal:',
        total: 'Total:',
        empty: 'Empty Shopping Card',
        continueShopping: 'Continue Shopping',
        sendViaWhatsapp: 'Send via Whatsapp',
    },
    errorModal: {
        title: 'An Error Occurred!',
        okay: 'Okay',
    },
    language: {
        english: 'English',
        arabic: 'Arabic',
        selectLanguage: 'Select language',
    },
    appAbout: {
        title: 'Effortless Digital Store Creation',
        subtitle: "Build your brand's digital store. Customize themes, categories, and branding. Include contact, about, and a map. Generate QR codes with your logo. Gather feedback and easily manage your store. Experience the future with upcoming layouts and advanced features",
    },
    appContact: {
        title: 'Register Now',
        subtitle: "Send us a request, and we'll handle the rest—bringing your business online",
        addressLabel: 'Address:',
        emailLabel: 'Email Us:',
        phoneLabel: 'Call Us:',
        whatsAppLabel: 'Whatsapp:',
        workingHoursLabel: 'working Hours:',
    },
    appFeatures: {
        title: 'Unlock Your Potential',
        description: 'Effortlessly build and manage your digital store with our powerful features',
        items: {
            designStore: {
                title: ' Design Your Dream Store',
                description: 'Make your digital store truly unique. Customize every aspect, from vibrant themes and intuitive categories to personalized headers, footers, and even your own logo',
                keyPoints: {
                    theme: 'Theme Builder',
                    category: 'Category Management',
                    branding: 'Branding Control',
                },
            },
            completePresence: {
                title: 'Build a Complete Online Presence',
                description: 'Provide a seamless user experience with essential pages. Easily manage a professional contact section with a map and a compelling about page to showcase your brand story',
                keyPoints: {
                    catalog: 'Catalog page',
                    about: 'About Page',
                    contact: 'Contact Page with Map',
                },
            },
            growBusiness: {
                title: 'Grow Your Business',
                description: 'Engage with your customers and drive growth. Generate custom QR codes for easy sharing and gather valuable feedback to improve your digital store and offerings',
                keyPoints: {
                    qr: 'QR Code Generator',
                    feedback: 'Customer Feedback',
                    visibility: 'Boost online visibility',
                },
            },
            effortlessControl: {
                title: 'Effortless Control',
                description: 'Manage your digital store with ease. Our intuitive interface makes it simple to update products, manage content, and keep your store running smoothly',
                keyPoints: {
                    ui: 'User-Friendly Interface',
                    updates: 'Seamless Updates',
                    efficiency: 'Save time and resources',
                },
            },
        },
    },
    appDemo: {
        intro: 'Click here to view an online',
        linkText: 'Digital Store',
    },
    appPricing: {
        title: 'Subscription Pricing',
        description: "Unleash your digital store's potential with tailored tools and unique features",
        firstYearType: 'yearly',
        popularBadge: 'Professional Plan',
        registerButton: 'Register',
        plans: {
            unlimited: {
                title: 'Unlimited Plan',
                description: 'Full access to core features, setup, and branding to launch your digital store or menu online.',
                keyPoints: {
                    branch: 'Single Branch Included',
                    products: 'Unlimited Products & Images',
                    catalog: 'Full Catalog Management',
                    branding: 'Custom Branding (Logo & Colors)',
                    qr: 'Dynamic QR Code Generator',
                    pages: 'Contact & About Pages',
                    maps: 'Google Maps Integration',
                    feedback: 'Customer Feedback System',
                    social: 'Share Social Media Accounts',
                    support: 'Customer Support',
                },
            },
            business: {
                title: 'Business Plan',
                description: 'Ideal for restaurants or stores with multiple branches. Advanced features and priority onboarding.',
                keyPoints: {
                    branches: 'Multiple Branches Included',
                    products: 'Unlimited Products & Images',
                    catalog: 'Full Catalog Management',
                    branding: 'Custom Branding (Logo & Colors)',
                    qr: 'Dynamic QR Code Generator',
                    pages: 'Contact & About Pages',
                    maps: 'Google Maps Integration',
                    feedback: 'Customer Feedback System',
                    social: 'Share Social Media Accounts',
                    prioritySupport: 'Priority Support',
                },
            },
            vip: {
                title: 'VIP Managed Plan',
                description: 'We handle everything for you — perfect for owners who want a hands-off experience. You focus on the business, we manage your online presence.',
                keyPoints: {
                    businessFeatures: 'All Business Plan Features',
                    management: 'Full Account Management (Images, Prices, Menu Updates)',
                    optimization: 'Advice & Optimization Suggestions',
                    support: 'Priority Support & Fast Response',
                },
            },
            extraFeatures: {
                title: 'Extra Features',
                description: 'Optional add-ons you can enable anytime to extend your store.',
                keyPoints: {
                    menuSections: 'Menu Sections — $20',
                    multiLanguage: 'Multi Language — $20',
                },
            },
        },
    },
    mainFooter: {
        copyrightSuffix: 'All rights reserved.',
        poweredBy: 'Powered by Storec',
        addressLabel: 'Address:',
        phoneLabel: 'Phone:',
        workingHoursLabel: 'working Hours:',
        contactInfoTitle: 'Contact Info',
        quickLinksTitle: 'Quick Links',
    },
    banner: {
        contact: 'Contact',
        about: 'About us',
        editImage: 'Edit Image',
        deleteImage: 'Delete Image',
        addBannerImage: 'Add Banner Image',
        caption: 'Caption',
        title: 'Title',
        imageCaption: 'Image Caption',
        sectionTitle: 'Section Title',
        pickImage: 'PICK IMAGE',
        imageRequired: 'Please provide an image.',
        captionError: 'Please enter a valid caption.',
        titleError: 'Please enter a valid title.',
        deleteConfirm: 'Are you sure ?',
        deleteQuestion: 'Do you want to proceed to delete Image ?',
        addedSuccess: 'Banner Item added successfully.',
        updatedSuccess: 'Image updated successfully.',
        deletedSuccess: 'Image deleted successfully.',
    },
    adminSections: {
        sectionTitle: 'Section Title',
        sectionDescription: 'Section Description',
        sectionDescription2: 'Section Description 2',
        buttonText: 'Button Text',
        buttonLink: 'Button Link',
        sectionAvailable: 'Section available',
        addImage: 'Add Image',
        imageRequired: 'Please provide an image.',
        titleError: 'Please enter a valid title.',
        descriptionError: 'Please enter a valid description.',
        buttonTextError: 'Please enter a valid button text.',
        buttonLinkError: 'Please enter a valid button link.',
        sectionUpdated: 'Section updated successfully.',
        placeholders: {
            title: 'title...',
            description: 'description...',
            buttonText: 'button text...',
            buttonLink: 'button link...',
        },
    },
    feedback: {
        addNew: 'Add New Feedback',
        addButton: 'Add Feedback',
        edit: 'Edit Feedback',
        delete: 'Delete Feedback',
        sectionTitle: 'Section Title',
        sectionAvailable: 'Section available',
        available: 'Available',
        nameLabel: '* Name',
        descriptionLabel: '* Description',
        emailLabel: '* Email',
        phoneLabel: 'Phone',
        feedbackStatus: '* Feedback Status',
        feedbackAvailable: '* Feedback available',
        displayEmail: 'Email:',
        displayPhone: 'Phone:',
        statusAccepted: 'Accepted',
        statusPending: 'Pending',
        statusRejected: 'Rejected',
        deleteQuestion: 'Do you want to proceed to delete Image ?',
        placeholders: {
            name: 'name...',
            description: 'description...',
            email: 'email...',
            phone: 'phone...',
            title: 'title...',
        },
        errors: {
            name: 'Please enter a valid name.',
            description: 'Please enter a valid description.',
            email: 'Please enter a valid email address.',
            phone: 'Please enter your phone number.',
            title: 'Please enter a valid title.',
        },
        messages: {
            sectionUpdated: 'Section updated successfully.',
            added: 'Feedback added successfully.',
            selected: 'Feedback selected successfully.',
            updated: 'Feedback updated successfully.',
            deleted: 'Feedback deleted successfully.',
        },
    },
    homeFeedback: {
        title: 'Customers Feedbacks',
    },
    contactSection: {
        title: 'Share Your Thoughts',
        subtitle: 'Let us know about your experience with our store. Your feedback helps us improve',
        sectionSubtitleLabel: 'Section Subtitle',
        subtitleError: 'Please enter a valid subtitle.',
        subtitlePlaceholder: 'subtitle...',
    },
    contactFeedbackForm: {
        namePlaceholder: '* Your Name',
        emailPlaceholder: '* Your Email',
        phonePlaceholder: 'Your Phone Number',
        feedbackLabel: '* Your Feedback',
        nameError: 'Please enter your name.',
        emailError: 'Please enter a valid email address.',
        phoneError: 'Please enter your phone number.',
        feedbackError: 'Please enter your feedback.',
    },
    contactInfoAdmin: {
        emailPlaceholder: '* Store Email',
        phonePlaceholder: '* Store Phone',
        whatsappPlaceholder: '* Store whatsapp',
        workingHoursPlaceholder: '* Working Hours',
        addressLabel: '* Our Address',
        addressPlaceholder: '* Address',
        emailError: 'Please enter a valid email address.',
        phoneError: 'Please enter your phone number.',
        whatsappError: 'Please enter a valid whatsapp id.',
        workingHoursError: 'Please enter a working hours.',
        addressError: 'Please enter restaurant address.',
        successMessage: 'Contacts added successfully.',
    },
    contactMap: {
        mapTitle: 'Store location map',
    },
    contactStoreDetails: {
        addressLabel: 'Visit Us:',
        emailLabel: 'Email Us:',
        phoneLabel: 'Call Us:',
        whatsAppLabel: 'Whatsapp:',
        workingHoursLabel: 'working Hours:',
    },
    aboutSection: {
        title: 'Who We Are',
    },
    nav: {
        store: 'Store',
        stores: 'Stores',
        contact: 'Contact',
        about: 'About',
        features: 'Features',
        pricing: 'Pricing',
        demo: 'Demo',
        joinUs: 'Join Us',
        login: 'Login',
        logout: 'Logout',
        profile: 'Profile',
        details: 'Details',
        theme: 'Theme',
        qrBuilder: 'QR Builder',
        settings: 'Settings',
    },
    auth: {
        paymentDue: 'Payment is due.',
        emailPlaceholder: 'Email',
        passwordPlaceholder: 'Password',
        emailRequired: 'Please input your Email!',
        emailInvalid: 'Please enter a valid email!',
        passwordRequired: 'Please input your Password!',
        signIn: 'Sign in',
        notRegistered: 'Not Registered?',
    },
    registerForm: {
        storeNamePlaceholder: '* Store Name',
        emailPlaceholder: '* Your Email',
        phonePlaceholder: '* Your Phone Number',
        nameError: 'Please enter your name.',
        emailError: 'Please enter a valid email address.',
        phoneError: 'Please enter a valid phone number.',
        submit: 'Submit',
        successMessage: 'Join request submitted successfully. We will contact you shortly.',
    },
    addStore: {
        title: 'Add Store',
        previous: 'Previous',
        upload: 'Upload',
        register: 'Register',
        successMessage: 'Registered successfully',
        fields: {
            ownerName: 'Owner name',
            username: 'Username',
            email: 'Email',
            phone: 'Phone',
            password: 'Password',
            role: 'Role',
            profileImage: 'Profile Image',
        },
        errors: {
            ownerNameRequired: 'Please input owner name!',
            usernameRequired: 'Please input store username!',
            emailRequired: 'Please input owner email!',
            emailInvalid: 'Please enter a valid email!',
            phoneRequired: 'Please input owner phone!',
            passwordRequired: 'Please input store password!',
            passwordMin: 'Password must be at least 6 characters!',
            roleRequired: 'Please input a role!',
        },
        roles: {
            store: 'Store',
        },
    },
    qrCode: {
        previous: 'Previous',
        upload: 'Upload',
        download: 'Download QR Code',
        generatedTitle: 'Generated QR Code',
        cards: {
            colors: 'Edit QR Colors',
            shapes: 'Edit QR Shape',
            logo: 'Upload Store Logo',
        },
        fields: {
            dotsColor: 'Dots Color',
            cornersSquareColor: 'Corners Square Color',
            cornersDotColor: 'Corners Dots Color',
            qrShape: 'QR Shape',
            dotsStyle: 'Dots Shape',
            cornersSquareStyle: 'Corners Square Shape',
            cornersDotStyle: 'Corners Dot Shape',
            storeLogo: 'Store Logo',
        },
        shapes: {
            square: 'Square',
            circle: 'Circle',
            dot: 'Dot',
            rounded: 'Rounded',
            dots: 'Dots',
            classy: 'Classy',
            'classy-rounded': 'Classy Rounded',
            'extra-rounded': 'Extra Rounded',
        },
        errors: {
            generate: 'Failed to generate the QR code. Please try again later or contact Storec support for assistance.',
        },
    },
    themeEditor: {
        title: 'Edit Your Theme',
        previous: 'Previous',
        mainColor: 'Main Color',
        secondaryColor: 'Secondary Color',
        saveChanges: 'Save Changes',
        changedSuccess: 'Theme changed successfully',
    },
    storeSettings: {
        title: 'Store Settings',
        previous: 'Previous',
        fields: {
            sectionsEnabled: 'Store Sections',
            multiLanguageEnabled: 'Multi-language Support',
            defaultLanguage: 'Default Language',
        },
        updatedTemplate: '{label} updated successfully',
    },
    storeDetails: {
        title: 'Store Details',
        previous: 'Previous',
        upload: 'Upload',
        successMessage: 'Submitted successfully',
        info: {
            storeUsername: 'Store username:',
            storeOwner: 'Store Owner:',
            ownerEmail: 'Owner Email:',
        },
        fields: {
            name: 'Store Name',
            description: 'Store Description',
            address: 'Text Address',
            addressLink: 'Address Link',
            embedAddressLink: 'Embed Address Link',
            email: 'Store Email',
            phone: 'Store Phone',
            whatsapp: 'Whatsapp Number',
            instagram: 'Instagram Link',
            facebook: 'Facebook Link',
            twitter: 'Twitter Link',
            linkedin: 'Linkedin Link',
            youtube: 'Youtube Link',
            tiktok: 'Tiktok Link',
            workingHours: 'Working Hours',
            currency: 'Currency',
            image: 'Store Image',
            backgroundImage: 'Background Image',
        },
        errors: {
            name: 'Please input store name!',
            description: 'Please input store description!',
            address: 'Please input store address!',
            addressLink: 'Please input store address link!',
            embedAddressLink: 'Please input store embed address link!',
            email: 'Please input store email!',
            phone: 'Please input store phone!',
            whatsapp: 'Please input store whatsapp!',
            instagram: 'Please input store instagram!',
            facebook: 'Please input store facebook!',
            twitter: 'Please input store twitter!',
            linkedin: 'Please input store linkedin!',
            youtube: 'Please input store youtube!',
            tiktok: 'Please input store tiktok!',
            workingHours: 'Please input store working hours!',
            currency: 'Please select a currency!',
            image: 'Please upload a store image!',
            backgroundImage: 'Please upload a background image!',
        },
        currencies: {
            usd: 'USD (United States Dollar)',
            lbp: 'LBP (Lebanese Pound)',
            iqd: 'IQD (Iraqi Dinar)',
            sar: 'SAR (Saudi Riyal)',
            kwd: 'KWD (Kuwaiti Dinar)',
            omr: 'OMR (Omani Rial)',
            qar: 'QAR (Qatari Riyal)',
            syp: 'SYP (Syrian Pound)',
            jod: 'JOD (Jordanian Dinar)',
            egp: 'EGP (Egyptian Pound)',
        },
    },
    userProfile: {
        editTitle: 'Edit Info',
        profileTitle: 'Profile Info',
        previous: 'Previous',
        upload: 'Upload',
        editButton: 'Edit Info',
        successMessage: 'Info updated successfully',
        fields: {
            ownerName: 'Owner Name',
            ownerEmail: 'Owner Email',
            ownerPhone: 'Owner Phone',
            profileImage: 'Profile Image',
        },
        errors: {
            ownerNameRequired: 'Please input owner name!',
            ownerEmailRequired: 'Please input owner email!',
            ownerEmailInvalid: 'Please enter a valid email!',
            ownerPhoneRequired: 'Please input owner phone!',
        },
        resetPassword: {
            title: 'Reset Password',
            newPassword: 'New Password',
            confirmPassword: 'Confirm Password',
            submit: 'Reset',
            mismatch: 'Passwords do not match',
            successMessage: 'Password reset successfully',
            errors: {
                newPasswordRequired: 'Please input new password!',
                confirmPasswordRequired: 'Please confirm new password!',
                passwordMin: 'Password must be at least 6 characters!',
            },
        },
        changePassword: {
            title: 'Change Password',
            currentPassword: 'Current Password',
            newPassword: 'New Password',
            confirmPassword: 'Confirm Password',
            submit: 'Submit',
            mismatch: 'Passwords do not match',
            samePassword: 'Passwords should not be the same',
            successMessage: 'Password changed successfully',
            errors: {
                currentPasswordRequired: 'Please input current password!',
                newPasswordRequired: 'Please input new password!',
                confirmPasswordRequired: 'Please confirm new password!',
                passwordMin: 'Password must be at least 6 characters!',
            },
        },
    },
    signupForm: {
        title: 'Signup Form',
        userName: 'User name',
        username: 'Username',
        email: 'Email',
        phone: 'Phone',
        password: 'Password',
        role: 'Role',
        profileImage: 'Profile Image',
        upload: 'Upload',
        signUp: 'Sign up',
        successMessage: 'Sign up successfully',
        roles: {
            store: 'Store',
        },
        errors: {
            userNameRequired: 'Please input user name!',
            usernameRequired: 'Please input user username!',
            emailRequired: 'Please input user email!',
            emailInvalid: 'Please enter a valid email!',
            phoneRequired: 'Please input user phone!',
            passwordRequired: 'Please input user password!',
            passwordMin: 'Password must be at least 6 characters!',
            roleRequired: 'Please input a role!',
        },
    },
    menu: {
        allCategories: 'All categories',
        sectionsLabel: 'Sections',
        emptyItems: 'Empty Items, nothing to show!',
        emptySections: 'Empty Store Sections, nothing to show!',
        messages: {
            categoriesSorted: 'Categories sorted successfully.',
            categorySortFailed: 'Category sort failed, please try again later.',
            storeSectionsSorted: 'Store section sorted successfully.',
            storeSectionSortFailed: 'Store section sort failed, please try again later.',
            productsSorted: 'Product sorted successfully.',
            productSortFailed: 'Product sort failed, please try again later.',
            categoryDeleted: 'Category deleted successfully.',
            categoryDeleteFailed: 'Category deletion failed, please try again later.',
            categoryUpdated: 'Category updated successfully.',
            categoryUpdateFailed: 'Category update failed, please try again later.',
            categoryAdded: 'Category added successfully.',
            categoryAddFailed: 'Category addition failed, please try again later.',
            productAdded: 'Product added successfully.',
            productAddFailed: 'Product addition failed, please try again later.',
            productDeleted: 'Product deleted successfully.',
            productDeleteFailed: 'Product deletion failed, please try again later.',
            productUpdated: 'Product updated successfully.',
            productUpdateFailed: 'Product update failed, please try again later.',
            sizeDeleted: 'Size deleted successfully.',
            sizeDeleteFailed: 'Size deletion failed, please try again later.',
            sizeAdded: 'New size added successfully.',
            sizeAddFailed: 'Size addition failed, please try again later.',
            sectionDeleted: 'Store section deleted successfully.',
            sectionDeleteFailed: 'Store section deletion failed, please try again later.',
            sectionUpdated: 'Store section updated successfully.',
            sectionUpdateFailed: 'Store section update failed, please try again later.',
            sectionAdded: 'Section added successfully.',
            sectionAddFailed: 'Section addition failed, please try again later.',
        },
        actions: {
            addNewCategory: 'Add New Category',
            addNewSection: 'Add New Section',
            addCategory: 'Add Category',
            addSection: 'Add Section',
            editCategory: 'Edit Category',
            editSection: 'Edit Store Section',
            addItem: 'Add Item',
            addNewItem: 'Add New Item',
            addNewSize: 'Add New Size',
            editItem: 'Edit Item',
            reset: 'Reset',
            deleteSize: 'DELETE SIZE',
            deleteProduct: 'DELETE PRODUCT',
            cancelDeletion: 'CANCEL DELETION',
        },
        fields: {
            name: 'Name',
            description: 'Description',
            price: 'Price',
            size: 'Size',
            imageCaption: 'Image Caption',
            itemAvailable: 'Item available',
        },
        placeholders: {
            categoryName: 'Category name',
            sectionName: 'Section name',
            itemName: 'Item name',
            itemDescription: 'Item description',
            itemPrice: 'Item price',
            caption: 'caption',
        },
        errors: {
            title: 'Please enter a valid title.',
            description: 'Please enter a valid description.',
            price: 'Please enter a valid price.',
            caption: 'Please enter a valid caption for image.',
            imageRequired: 'Please provide an image.',
        },
        confirm: {
            areYouSure: 'Are you sure ?',
            deleteCategory: 'Do you want to proceed to delete category ?',
            deleteSection: 'Do you want to proceed to delete store section ?',
            deleteProduct: 'Do you want to proceed to delete product',
            orSize: 'or size',
        },
        sizes: {
            none: 'None',
            small: 'صغير',
            medium: 'وسط',
            large: 'كبير',
            family: 'عائلي',
            regular: 'عادي',
            mashrouha: 'مشروحة',
        },
        media: {
            upload: 'Upload',
            pickImage: 'PICK IMAGE',
            bannerAlt: 'Store Banner',
            storeAlt: 'Store',
        },
    },
    storeList: {
        searchPlaceholder: 'Search for a store',
        filters: {
            registered: 'registered',
            unregistered: 'unregistered',
        },
        statuses: {
            unsubscribed: 'UnSubscribed',
            duePayment: 'Due Payment',
            active: 'Active',
            restrictedTag: 'Restricted',
        },
        menu: {
            restrictStore: 'Restrict Store',
            unRestrictStore: 'UnRestrict Store',
            setPaidDate: 'Set Paid Date',
            add: 'Add',
        },
        actions: {
            restrict: 'Restrict',
            unRestrict: 'UnRestrict',
        },
        confirm: {
            areYouSure: 'Are you sure ?',
            restrict: 'Do you want to proceed to {action} store {store}',
            payment: 'Do you want to proceed to set payment Date ?',
            setDate: 'Set Date',
            cancel: 'CANCEL',
        },
        errors: {
            storeNotFound: 'Store not found!',
        },
        messages: {
            restrictSuccess: 'Store updated successfully.',
            paymentSuccess: 'Payment date set successfully.',
        },
    },
};

export default en;
